<mat-icon 
    [matTooltip]="message"
    [matTooltipClass]="tooltipClass"
    [matTooltipPosition]="position"
    [matTooltipShowDelay]="showDelay"
    [matTooltipHideDelay]="hideDelay"
    [matTooltipDisabled]="disabled"
    aria-label="Icon displays a tooltip">
    {{ icon }}
</mat-icon>